module.exports = __webpack_public_path__ + "img/reagent-1.9a665ba5.png";